import axios from 'axios';
import { path } from '../constants';

export const getAccessToken = () => localStorage.getItem("access_token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");
export const setTokens = (accessToken: string, refreshToken: string) => {
  localStorage.setItem("access_token", accessToken);
  localStorage.setItem("refresh_token", refreshToken);
};
export const clearTokens = () => {
  localStorage.clear();
};

const createAxiosInstance = (baseURL: string | undefined) => {
  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const apiKey = process.env.REACT_APP_API_KEY
      const chainName = localStorage.getItem('blockchain')
      const network = localStorage.getItem('network')

      if (apiKey) {
        config.headers["ngrok-skip-browser-warning"] = true
        config.headers["api-key"] = apiKey;
        config.headers["blockchain"] = chainName?.toLowerCase();
        config.headers["network"] = network?.toLowerCase();
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      const refreshToken = getRefreshToken();
      if (error.response && error.response.data.httpStatus === 404) {
        window.location.href = path.PAGE_NOT_FOUND;
      } else if (
        refreshToken &&
        error.response &&
        error.response.data.httpStatus === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        try {
          const headers = {
            Authorization: `Bearer ${refreshToken}`,
          };
          const res = await axios.get(`${baseURL}/auth/refresh_token`, { headers });
          setTokens(res.data.result.access_token, res.data.result.refresh_token);
          originalRequest.headers.Authorization = `Bearer ${res.data.result.access_token}`;
          return axios(originalRequest);
        } catch (error) {
          clearTokens();
          window.location.href = path.ROOT;
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const axiosInstance = createAxiosInstance(process.env.REACT_APP_BASE_URL);
